import { render } from "./AppFooter.vue?vue&type=template&id=2b4b1564&scoped=true"
const script = {}

import "./AppFooter.vue?vue&type=style&index=0&id=2b4b1564&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b4b1564"]])

export default __exports__